<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26">
		<g id="Group_42768" data-name="Group 42768" transform="translate(-684 -1844)">
			<g id="Ellipse_757" data-name="Ellipse 757" transform="translate(684 1844)" fill="none" stroke="#e83454" stroke-width="1">
				<circle cx="13" cy="13" r="13" stroke="none" />
				<circle cx="13" cy="13" r="12.5" fill="none" />
			</g>
			<g id="Group_42764" data-name="Group 42764">
				<path
					id="Path_29771"
					data-name="Path 29771"
					d="M9.99,12.972a3.99,3.99,0,0,0,3.99-3.99v-1M9.99,12.972A3.99,3.99,0,0,1,6,8.982v-1m3.99,4.988v2.494m-2.494,0h4.988"
					transform="translate(687.01 1848.517)"
					fill="none"
					stroke="#e73457"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="1.5"
				/>
				<path
					id="Path_29772"
					data-name="Path 29772"
					d="M10.39,12.473A2.394,2.394,0,0,1,8,10.079V5.894a2.394,2.394,0,1,1,4.789,0v4.184A2.394,2.394,0,0,1,10.39,12.473Z"
					transform="translate(686.611 1846.769)"
					fill="#e73457"
				/>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'RecordSvg',
};
</script>
